<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-form @submit.prevent="recovery">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>{{ $t("registrarse") }}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  :label="$t('contrasena')"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="form.password"
                  autocomplete="off"
                  required
                  autofocus
                />
                <v-text-field
                  :label="$t('confirmar_contrasena')"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="form.password_confirmation"
                  autocomplete="off"
                  required
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn type="submit" color="primary">{{ $t("enviar") }}</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      providerId: null,
      form: {
        codigo: this.$route.params.code,
      },
      btnDisabled: false,
    };
  },
  methods: {
    async recovery() {
      this.openLoader();
      const request = await this.sendRequest(
        `${this.$store.state.proveedorUrl}${this.providerId}/recovery`,
        this.form,
        "POST"
      );
      if (request.success) {
        this.showSuccessMessage(request.message);
        setTimeout(() => (window.location = "/"), 2000);
      }
      this.closeLoader();
    },
  },
  async created() {
    const request = await this.sendRequest(
      `${this.$store.state.proveedorUrl}code-check`,
      {
        code: this.$route.params.code,
      },
      "GET"
    );
    if (request.success) {
      this.providerId = request.data.id;
    } else {
      setTimeout(() => (window.location = "/"), 2000);
    }
  },
};
</script>